import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import styles from '../../styles.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField } from "@vaadin/react-components";
import { Icon } from '@vaadin/react-components/Icon.js';
import { ExcelDownload } from "./Reusables";
import PrintIcon from '@mui/icons-material/Print';
import ExcelUploadButton from "./ExcelUploadButton";
import CameraAltSharpIcon from '@mui/icons-material/CameraAltSharp';
import QRScanner from "./QRScanner";

const HeaderSection = ({
    title,
    addNewPath,
    searchKey,
    handleSearch,
    sortedRows,
    fields,
    labels,
    filename,
    paginationInfo,
    controller,
    handleChangePage,
    effectiveTotalCount,
    View_Pending_Order,
    stocks,
    PrintIcon_print,
    excelfileUploads,
    openscanner,
    loading_slip,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isScannerOpen, setIsScannerOpen] = useState(false);
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const user_role = userD?.result?.userInfo?.user_role;

    const isMastersPage = location.pathname.startsWith('/masters');
    const canAddNew = user_role !== 'management' &&
        (user_role !== 'admin' || isMastersPage);

    const handleOpenScanner = () => setIsScannerOpen(true);
    const handleCloseScanner = () => setIsScannerOpen(false);
    const handleScan = (data) => {
        if (openscanner?.onScan) openscanner.onScan(data);
        setIsScannerOpen(false);
    };

    return (
        <>
            {/* Title — upar, same white background */}
            <Typography
                className={`${styles.header_txt}`}
                sx={{
                    padding: '12px 20px 4px 20px',
               
                }}
            >
                {title}
            </Typography>

            {/* Export | Search(full width) | Add New — ek hi row */}
            <Box sx={{
                display: 'flex',
                alignItems: 'stretch', 
                gap: '10px',
                padding: '8px 20px 12px 20px',
                background: '#fff',
                flexWrap: 'nowrap',
                borderBottom: '1px solid #e0e0e0',
            }}>

                {/* Optional: Print button */}
                {PrintIcon_print && (
                    <Button
                        className={`${styles.action_btn}`}
                        onClick={PrintIcon_print.onClick}
                        sx={{ flexShrink: 0 }}
                    >
                        <PrintIcon />
                    </Button>
                )}

                {/* Optional: Scanner button */}
                {openscanner && (
                    <Button
                        className={`${styles.action_btn}`}
                        onClick={handleOpenScanner}
                        sx={{ flexShrink: 0 }}
                    >
                        <CameraAltSharpIcon />
                    </Button>
                )}

                {/* Optional: Excel Upload button */}
                {excelfileUploads && (
                    <Box sx={{ flexShrink: 0 }}>
                        <ExcelUploadButton handleFileChange={excelfileUploads} />
                    </Box>
                )}

                {/* Export button — fixed, never shrinks */}
                <Button
                    className={`${styles.export_btn}`}
                    sx={{ flexShrink: 0, alignSelf: 'center', height: '36px'  }}
                >
                    <ExcelDownload
                        data={sortedRows}
                        fields={fields}
                        labels={labels}
                        filename={filename}
                    />
                    <Typography className={styles.btn_txt}>Export</Typography>
                </Button>

                {/* Search bar — fills ALL remaining space */}
                <Box sx={{flex: '1 1 auto', minWidth: 0, alignSelf: 'center',mb:'6px', height: '36px' }}>
                    <TextField
                        placeholder="Search..."
                        clearButtonVisible
                        className={`${styles.searchbar}`}
                        value={searchKey}
                        onInput={handleSearch}
                        style={{ width: '100%' }}
                    >
                        <Icon slot="prefix" icon="vaadin:search" />
                    </TextField>
                </Box>

                {/* Optional: Loading Slip button */}
                {loading_slip && (
                    <Button
                        variant="contained"
                        onClick={() => navigate(loading_slip)}
                        className={`${styles.addnew_btn}`}
                        sx={{ flexShrink: 0 }}
                    >
                        <Typography className={styles.addnew_btn_txt}>Loading Slip</Typography>
                    </Button>
                )}

                {/* Add New button — fixed, never shrinks */}
                {addNewPath && canAddNew && (
                    <Button
                        variant="contained"
                        onClick={() => navigate(addNewPath)}
                        className={styles.addnew_btn}
                        sx={{flexShrink: 0, alignSelf: 'center', height: '36px'}}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                        >
                            <path
                                d="M11.0621 11.0621H6.26805C5.75002 11.0621 5.33008 11.4821 5.33008 12.0001C5.33008 12.5181 5.75002 12.938 6.26805 12.938H11.0621V17.7321C11.0621 18.2501 11.4821 18.6701 12.0001 18.6701C12.5181 18.6701 12.938 18.2501 12.938 17.7321V12.938H17.7321C18.2501 12.938 18.6701 12.5181 18.6701 12.0001C18.6701 11.4821 18.2501 11.0621 17.7321 11.0621H12.938V6.26805C12.938 5.75002 12.5181 5.33008 12.0001 5.33008C11.4821 5.33008 11.0621 5.75002 11.0621 6.26805V11.0621Z"
                                fill="#ffffff"
                            />
                        </svg>
                        <Typography className={styles.addnew_btn_txt}>Add New</Typography>
                    </Button>
                )}
            </Box>

            {openscanner && (
                <QRScanner
                    open={isScannerOpen}
                    onClose={handleCloseScanner}
                    onScan={handleScan}
                />
            )}
        </>
    );
};

export default HeaderSection;